export const SET_INDICATORS = 'INDICATORS/SET_INDICATORS'